import { defineStore } from 'pinia'

// *** notificationStore ***
// notification object {
//   msg: String
//   color: "info" || String
//   icon: null || String
//   link: null || Link {
//     href: String
//     text: String
//   }
//   showClose: null || Boolean
//   timeout: null || Number
//   location: null || String // aligns the toast to the specified area
//   id: String // auto-generated
//   show: Boolean // auto-generated
// }
// see GlyueToast.vue for more info

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    _notifications: [],
    _banners: [ ]
  }),
  getters: {
    notifications: (state) => state._notifications,
    getNotificationById: (state) => (id) => state._notifications.find(x => x.id === id),
    banners: (state) => state._banners,
  },
  actions: {
    createNotification(inputNotification) {
      const id = `notif-${Math.random().toString(36).slice(2)}${new Date().getTime().toString(36)}`
      const timeout = setTimeout(() => this.removeNotificationById(id), inputNotification.timeout || 5000)

      return {
        ...inputNotification,
        id,
        show: true,
        timeout,
      }

    },
    addNotification(notification) {
      let newNotification = this.createNotification(notification)
      this._notifications.unshift(newNotification)
      return newNotification.id
    },
    removeNotificationById(id) {
      const removedNotificationId = this._notifications.findIndex(x => x.id === id)
      if (removedNotificationId === -1) {
        return
      }
      clearTimeout(this._notifications[removedNotificationId].timeout)
      this._notifications = [...this._notifications.slice(0, removedNotificationId), ...this._notifications.slice(removedNotificationId + 1)]
    },
    clearNotifications() {
      this._notifications.forEach(notification => clearTimeout(notification.timeout))
      this.$reset()
    },
    append_notification(notification) {
      this._notifications.push(this.createNotification(notification))
    },
    addBanner(inputBanner) {
      this._banners.push(inputBanner)
    },
    removeBanner(){
      this._banners.shift()
    }
  }
})
